import SimpleFormItem from "./SimpleFormItem";
import {ScreenConfig} from "../../config/ScreenConfig";
import {useRoomConfig} from "../../model/RoomConfigContext";
import {useSeatConfig} from "../../model/SeatConfigContext";
import {useScreenConfig} from "../../model/ScreenConfigContext";
import {useAudioConfig} from "../../model/AudioConfigContext";
import {CameraMode, useInteractionContext} from "../../model/InteractionContext";
import {useErrorContext} from "../../model/ErrorContext";

export default function Menu() {

    const {
        width,
        height,
        depth,
        aisleWidth,
        aisleMode,
        floorColor,
        mainLightOn,
        setMainLightOn,
        floorLedsOn,
        roofHeight,
    } = useRoomConfig();
    const {
        numRows,
        numSeats,
        preferredRow,
        distance,
        id: seatID,
        modelID,
        showOccupants,
        setShowOccupants
    } = useSeatConfig();
    const {
        aspectRatio,
        screenSize,
        id: screenID,
        screenFloorDistance,
        projectorPosition,
    } = useScreenConfig();

    const {
        errors,
    } = useErrorContext()

    const {setCameraMode} = useInteractionContext();
    const {
        id: audioConfigId,
        speakerType,
        surroundType,
        rearInCeiling,
        transparantWalls,
        numCeilingSpeakers,
        showCones,
        setShowCones,
        frontPositions,
        ceilingPositions,
        sidePositions,
        rearPositions
    } = useAudioConfig();

    function scrollParentToChild(parent, child) {

        document.getElementById('RightInfoContainer').classList.remove("collapsed");
        document.getElementById('collapse').style.display = "block";
        document.getElementById('expand').style.display = "none";

        // Where is the parent on page
        var parentRect = parent.getBoundingClientRect();
        // What can you see?
        var parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
        };

        // Where is the child
        var childRect = child.getBoundingClientRect();
        // Is the child viewable?
        var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

        // if you can't see the child try to scroll parent
        if (!isViewable) {
            // Should we scroll using top or bottom? Find the smaller ABS adjustment
            const scrollTop = childRect.top - parentRect.top;
            const scrollBot = childRect.bottom - parentRect.bottom;
            if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
                // we're near the top of the list
                parent.scrollTop += scrollTop;
            } else {
                // we're near the bottom of the list
                parent.scrollTop += scrollBot;
            }
        }
    }


    async function postData(url = '', data = {}) {
        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    function collapseMenu() {
        document.getElementById('App').classList.add('menu-hidden');
        document.getElementById('RightInfoContainer').classList.add('collapsed');
        document.getElementById('collapse').style.display = "none";
        document.getElementById('expand').style.display = "block";
        document.getElementById('show3d').classList.add('hidden');
        document.getElementById('showConf').classList.remove('hidden');
        document.getElementById('showConf').classList.add('visible');
    }

    function expandMenu() {
        document.getElementById('App').classList.remove('menu-hidden');
        document.getElementById('RightInfoContainer').classList.remove("collapsed");
        document.getElementById('collapse').style.display = "block";
        document.getElementById('expand').style.display = "none";
        document.getElementById('show3d').classList.remove('hidden');
        document.getElementById('showConf').classList.add('hidden');
    }

    function collapseWindow() {
        document.getElementById('App').classList.remove('fullScreen')
        document.getElementById('collapsewindow').style.display = "none";
        document.getElementById('expandwindow').style.display = "block";
    }

    function expandWindow() {
        document.getElementById('App').classList.add("fullScreen");
        document.getElementById('collapsewindow').style.display = "block";
        document.getElementById('expandwindow').style.display = "none";
    }

    function submitData() {
        const configUrl = 'https://www.cinedream.be/designer/configuration';

        const postBody = {
            width: width,
            height: height,
            depth: depth,
            aisleWidth: aisleWidth,
            aisleMode: aisleMode,
            floorColor: floorColor,
            floorLedsOn: floorLedsOn,
            numRows: numRows,
            numSeats: numSeats,
            preferredRow: preferredRow,
            distance: distance,
            modelID: modelID,
            aspectRatio: aspectRatio,
            screenSize: screenSize,
            screenFloorDistance: screenFloorDistance,
            projectorPosition: projectorPosition,
            audioConfigId: audioConfigId,
            transparantWalls: transparantWalls,
            speakerType: speakerType,
            surroundType: surroundType,
            rearInCeiling: rearInCeiling,
            numCeilingSpeakers: numCeilingSpeakers,
            frontPositions: frontPositions,
            ceilingPositions: ceilingPositions,
            sidePositions: sidePositions,
            rearPositions: rearPositions,
            screenConfig: ScreenConfig,
            screenId: screenID,
            seatId: seatID,
            roofHeight: roofHeight,
            errors: errors,
            version: 2,
            email: document.getElementById('mail').value,
            name: document.getElementById('name').value,
            region: document.getElementById('region').value,
            newsletter: document.getElementById('newsletter').checked,
        };

        postData(configUrl, postBody)
            .then(data => {
                if (data['data']['ok'] === 1) {
                    document.getElementById('summaryForm').getElementsByClassName('thanks-content')[0].style.display = "block";
                    document.getElementById('summaryForm').getElementsByClassName('error-content')[0].style.display = "none";
                    document.getElementById('summaryForm').getElementsByClassName('form-content')[0].style.display = "none";
                }
                else {
                    document.getElementById('summaryForm').getElementsByClassName('thanks-content')[0].style.display = "none";
                    document.getElementById('summaryForm').getElementsByClassName('error-content')[0].style.display = "block";
                    document.getElementById('summaryForm').getElementsByClassName('form-content')[0].style.display = "block";
                }
            });
    }

    return (
        <div>
            <ul>
                <li><button onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('room'))}>1. Ruimte</button></li>
                <li><button onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('video'))}>2. Scherm en projectie</button></li>
                <li><button onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('audio'))}>3. Audio setup</button></li>
                <li><button onClick={() => scrollParentToChild(document.getElementById('menu'), document.getElementById('seats'))}>4. Zitcomfort</button></li>
                <li><button onClick={() => document.getElementById('summaryForm').style.display = "block"}>5. SAMENVATTING</button></li>
            </ul>
            <button id="show3d" onClick={() => collapseMenu()}>Toon 3D weergave</button>
            <button id="showConf" onClick={() => expandMenu()}>Toon configuratie</button>
            <button id="expandwindow" className="full screenoption" onClick={() => expandWindow()}>Volledig scherm</button>
            <button id="collapsewindow" className="window screenoption" onClick={() => collapseWindow()}>Sluit volledig scherm</button>
            <label className="showcones" data-active={showCones}>Geluidsgolven<input id="showcones" type="checkbox" checked={showCones} onChange={e => setShowCones(e.target.checked)}/></label>
            <label className="light" data-active={mainLightOn}>Licht<input id="light" type="checkbox" checked={mainLightOn} onChange={e => setMainLightOn(e.target.checked)}/></label>
            <label className="sightlines" data-active={showOccupants}>Zichtlijnen<input id="sightlines" type="checkbox" checked={showOccupants} onChange={e => setShowOccupants(e.target.checked)}/></label>
            <div className="camera">
                <div className="inner">
            <button className="camera orbit" data-info={CameraMode} onClick={() => setCameraMode(CameraMode.Orbit)}>Overzicht</button>
            <button className="camera topdown" data-info={CameraMode} onClick={() => setCameraMode(CameraMode.TopDown)}>Bovenzicht</button>
            <button className="camera seat" data-info={CameraMode} onClick={() => setCameraMode(CameraMode.Seat)}>In zetel</button>
                </div>
            </div>
            <button id="collapse" onClick={() => collapseMenu()}>&raquo;</button>
            <button id="expand" onClick={() => expandMenu()}>&laquo;</button>
            <div className="summaryForm" id="summaryForm">
                <div className="background"></div>
                <div className="form">
                    <button className="close" onClick={() => document.getElementById('summaryForm').style.display = "none"}>x</button>
                    <div className="thanks-content">
                        Bedankt om gebruik te maken van de designer. Je ontvangt binnenkort een e-mail met meer informatie over je configuratie.
                    </div>
                    <div className="error-content">
                        Geef uw naam en een geldig e-mail adres op om de specificaties via e-mail te ontvangen.
                    </div>
                    <div className="form-content">
                <h3>Samenvatting</h3>
                <p>Wilt u gratis en vrijblijvend een overzichtelijke persoonlijke samenvatting ontvangen van deze configuratie? Vul uw e-mail adres in en u ontvangt deze binnen de 5 minuten.</p>
                    <p>Dit overzicht bevat uitgebreide informatie, alsook een link om de configuratie terug te openen.</p>
                    <div className="row"><span className="label">Naam*</span><SimpleFormItem id="name" type="text"/></div>
                    <div className="row"><span className="label">E-mail adres*</span><SimpleFormItem id="mail" type="text"/></div>
                        <div className="row"><span className="label">Regio</span><SimpleFormItem id="region" type="select">
                            <option value="Antwerpen">Antwerpen</option>
                            <option value="Limburg">Limburg</option>
                            <option value="Oost-Vlaanderen">Oost-Vlaanderen</option>
                            <option value="Vlaams-Brabant">Vlaans-Brabant</option>
                            <option value="West-Vlaanderen">West-Vlaanderen</option>
                            <option value="Groningen">Groningen</option>
                            <option value="Friesland">Friesland</option>
                            <option value="Drenthe">Drenthe</option>
                            <option value="Overijssel">Overrijssel</option>
                            <option value="Gelderland">Gelderland</option>
                            <option value="Utrecht">Utrecht</option>
                            <option value="Noord-Holland">Noord-Holland</option>
                            <option value="Zuid-Holland">Zuid-Holland</option>
                            <option value="Zeeland">Zeeland</option>
                            <option value="Noord-Brabant">Noord-Brabant</option>
                            <option value="Limburg">Limburg</option>
                            <option value="Andere">Andere</option>
                        </SimpleFormItem></div>
                    <div className="row"><label><SimpleFormItem type="checkbox" id="newsletter"/> Schrijf je in voor de nieuwsbrief en blijf op de hoogte van de laatste nieuwtjes</label></div>
                    <div className="row">
                        <button className="submit" onClick={() => submitData()}>Stuur mij de samenvatting</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
